var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tiny-editor"},[_c('editor',{attrs:{"value":_vm.value,"init":_vm.init,"model-events":"change input undo redo"},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }